// Centralized to make future max-length changes easy across views/tests.
export const DESCRIPTION_MAX_LENGTH = 10000;
